import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-dialog-question',
  templateUrl: './dialog-question.component.html'
})

// https://onthecode.co.uk/create-confirm-dialog-angular-material/

export class DialogQuestionComponent {
  title: string;
  message: string;
  reason: string;

  constructor(public dialogRef: MatDialogRef<DialogQuestionComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogQuestionModel) {
    // Update view with given values
    this.title = data.title;
    this.message = data.message;
  }

  onConfirm(): void {
    // Close the dialog, return true
    this.dialogRef.close(true);
  }

  onDismiss(): void {
    // Close the dialog, return false
    this.dialogRef.close(false);
  }

  isValid(): boolean {
    let el = <any>document.getElementById('izitoast--input');
    return !(el.value === null || el.value === '');
  }
}

/**
 * Class to represent confirm dialog model.
 * It has been kept here to keep it as part of shared component.
 */
export class DialogQuestionModel {
  constructor(public title: string
    , public message: string
    ) {
  }
}
